import { SET_USERS } from "./actionTypes";

const DEFAULT_DATA = {
  isApiCallInProgress: true,
  payload: null,
};
const initialState = {
  getUsers: {
    ...DEFAULT_DATA,
  },
};
const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERS:
      return {
        ...state,
        getUsers: {
          ...state.getUsers,
          ...action.value,
        },
      };
    default:
      return state;
  }
};

export default SearchReducer;
